import script from "./PhoneBookMain.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneBookMain.vue?vue&type=script&setup=true&lang=js"

import "./PhoneBookMain.vue?vue&type=style&index=0&id=777f681c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777f681c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QFab from 'quasar/src/components/fab/QFab.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.1.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QFab});
